import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import CallCenterList from "./callcenterlist";

const CallCenterListPage = () => {
  return (
    <NavHeightAdjust>
      <CallCenterList />
    </NavHeightAdjust>
  );
};

export default CallCenterListPage;
